<template>
  <div>
    <DialogBottomSheet
      :is-visible="isDialogOpened"
      :width="isMobile ? undefined : 375"
      content-class="rounded-0"
      @input="handleInput"
    >
      <v-card
        tile
        class="pt-6 px-4 pb-4"
      >
        <v-form @submit.prevent="applyFilter">
          <FieldPrices
            v-model="filtersStore.unsavedFilters"
            :is-visible="isDialogOpened"
            autofocus
            class="mb-4"
          >
            <template #title>
              <div class="text-h6 mb-4">
                {{ t('Стоимость приёма', options) }}
              </div>
            </template>
          </FieldPrices>
          <BtnShowDoctors
            :active="isDialogOpened"
            @click:close="closeDialog"
            @click:submit="applyFilter"
          />
        </v-form>
      </v-card>
    </DialogBottomSheet>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import I18NextVue from 'i18next'
import { debounce, dispatchCustomEventGlobally } from 'www/utils'
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'
import getPriceLabel from 'www/vue_components/common/TheFilters/doctors/components/PriceFilters/functions/getPriceLabel'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import BtnShowDoctors from 'www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue'
import FieldPrices from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/FieldPrices/FieldPrices.vue'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('PriceFilters')

const isMobile = window.MOBILE_VERSION
const priceLabel = computed(() => getPriceLabel(filtersStore.filters.price))

watch(
  () => filtersStore.filters.price,
  () => {
    chipsStore.updatePriceChip({
      name: priceLabel.value,
      isActive: !!priceLabel.value,
      dropdown: !priceLabel.value,
      isVisible: !!priceLabel.value,
      onClick: openDialog,
      async onReset() {
        filtersStore.updateFilters({
          price: {
            from: undefined,
            to: undefined,
          },
        })

        await updateDoctorListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)

const applyFilter = async () => {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  await updateDoctorListPage()
}

// Делаем задержку такую же как в дочернем компоненте, чтобы дочерний компонент не затёр данные по таймауту
const debouncedHandleInput = debounce(() => {
  filtersStore.resetUnsavedFilters()
}, 700)

const handleInput = () => {
  debouncedHandleInput()
}
</script>
